// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    drakeVersion: "5.0.0",
    //apiUrl: "https://localhost:7199/",
    //baseUrl: "https://localhost:4200/",
    apiUrl: "https://apiturckbanner.3idrake.it/",
    baseUrl: "https://turckbanner.3idrake.it/",
    firebase: {
        apiKey: "AIzaSyD253ECJPVDLp5GTDHpNom3IBFwA7Zw9Ak",
        authDomain: "drakev5notifications.firebaseapp.com",
        projectId: "drakev5notifications",
        messagingSenderId: "415940804963",
        appId: "1:415940804963:web:3b85a35934522d7b3a1356",
        vapidKey: 'BKXiHhU3HCmVq2BrpjqhLyLDWlBt1tn7WbhJny6BPb4ZLX_rNnDkggjLiXypqrjb2OGaUNZB1l4SnUCVra71FzQ', // Aggiungi questa linea

    },
    mqtt: {
        enable:true,
        //address: "192.168.200.12",
        protocol: 'ws',
        address: "192.168.200.10",
        port: 5000
    },
    locationDefaults:{
        lat: 45.464664, 
        lon: 9.188540
    },
    enableTwoFactor: false,
    enableLoginCaptcha: false,
    enableSignUp: false,
    enableSettings: false,
    autoApprove: false,
    modules:{
        chat: false,
        help: false,
        chatBot: false
    },
    appLink: {
        protocol: "turkcbanner",
        androidAppId: "io.turkcbanner.starter",
        iosAppId: "6745520005"
    },
chartColors: [
  "#f4f1de", // beige chiaro
  "#e07a5f", // terracotta
  "#3d405b", // blu-grigio scuro
  "#81b29a", // verde salvia
  "#f2cc8f", // sabbia calda
  "#2a6f97", // blu oceano
  "#9bb1ff", // azzurro pastello
  "#dbd3d8", // grigio chiaro
  "#6a994e", // verde oliva intenso
  "#a44a3f", // rosso mattone
  "#264653", // blu petrolio scuro
  "#f77f00", // arancio vivo
  "#fcbf49", // giallo ocra
  "#8ecae6", // azzurro chiaro freddo
  "#219ebc", // turchese medio
  "#ffb4a2", // pesca chiaro
  "#b5838d", // malva tenue
  "#6d6875", // grigio-lilla
  "#355070", // blu ardesia
  "#90be6d"  // verde lime soft
]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
